<template>
    <NModal
        :show="show"
        preset="card"
        title="Change password"
        :mask-closable="true"
        :style="{
            width: '100%',
            height: '100vh',
        }"
        @close="colseFun()"
        @mask-click="colseFun()"
    >
        <div w-full h-full flex items-center justify-center flex-col>
            <div style="width: 60%; color: black; font-weight: 400; font-size: 16px">
                <div>
                    <n-icon size="16">
                        <PSD />
                    </n-icon>
                    {{ t('page.system.user.password_rules') }}:
                </div>
                <div flex flex-wrap gap-x-4 mt-2>
                    <div flex-1>• {{ t('page.system.user.min_length') }}</div>
                    <div flex-1>• {{ t('page.system.user.max_length') }}</div>
                    <div flex-1>• {{ t('page.system.user.validity_maxperiod') }}</div>
                </div>
                <div flex flex-wrap gap-x-4 mt-1>
                    <div flex-1>• {{ t('page.system.user.require_special_char') }}</div>
                    <div flex-1>• {{ t('page.system.user.require_uppercase') }}</div>
                    <div flex-1>• {{ t('page.system.user.require_lowercase') }}</div>
                </div>
                <div flex flex-wrap gap-x-4 mt-1>
                    <div flex-1>• {{ t('page.system.user.require_digit') }}</div>
                    <div flex-1>• {{ t('page.system.user.no_spaces_allowed') }}</div>
                    <div flex-1>• {{ t('page.system.user.username_not_allowed') }}</div>
                </div>
                <div flex flex-wrap gap-x-4 mt-1>
                    <div flex-1>• {{ t('page.system.user.not_match_last_n_passwords') }}</div>
                    <div flex-1>
                        •
                        {{
                            t('page.system.user.allowed_special_characters')
                        }}:`~!@^()_+-=[]{};':".&lt;&gt;?
                    </div>
                    <div flex-1 />
                </div>
            </div>
            <div style="width: 60%; margin-top: 20px">
                <n-form ref="formRef" :model="model" :rules="rules">
                    <n-form-item path="oldPassword" label="Old password">
                        <NInput
                            v-model:value="model.oldPassword"
                            type="password"
                            show-password-on="click"
                            placeholder="Old password"
                        />
                    </n-form-item>
                    <n-form-item path="newPassword" label="New password">
                        <NInput
                            v-model:value="model.newPassword"
                            type="password"
                            show-password-on="click"
                            placeholder="New password"
                        />
                    </n-form-item>
                    <n-form-item path="confirmPassword" label="Confirm password">
                        <NInput
                            v-model:value="model.confirmPassword"
                            type="password"
                            show-password-on="click"
                            placeholder="Confirm password"
                        />
                    </n-form-item>
                </n-form>
            </div>
            <div>
                <NButton mr-2 color="#000" @click="confirm">
                    <div>{{ t('button.save') }}</div>
                </NButton>
            </div>
        </div>
    </NModal>
</template>

<script lang="ts" setup>
import { NButton, NInput, useMessage } from 'naive-ui';
import type { FormInst, FormRules } from 'naive-ui';
import { useRequests } from './request';
import PSD from '~icons/assets-icons/psd';

interface ModelType {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}
const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
});

const emits = defineEmits(['update:close']);

const { modifyPwd, changePwd } = useRequests();
const message = useMessage();
const { t, locale } = useTypedI18n();

const formRef = ref<FormInst | null>(null);

const model = ref<ModelType>({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
});

const rules: FormRules = {
    oldPassword: [
        {
            required: true,
        },
    ],
    newPassword: [
        {
            required: true,
        },
    ],
    confirmPassword: [
        {
            required: true,
        },
        {
            validator: async (_rule, value) => {
                if (value !== model.value.newPassword) {
                    throw new Error('Passwords do not match');
                }
                // 如果验证通过，不抛出错误即可（或 return true）
            },
            trigger: 'blur',
        },
    ],
};
const colseFun = () => {
    emits('update:close', false);
    // 清空
    model.value = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
    };
};
const confirm = () => {
    // 调用表单的 validate 方法进行表单验证
    formRef.value?.validate((valid) => {
        if (!valid) {
            // 如果验证通过，则进行后续操作
            changePwd({
                oldPwd: model.value.oldPassword,
                newPwd: model.value.newPassword,
            }).then((res) => {
                if (res) {
                    model.value.oldPassword = '';
                    model.value.newPassword = '';
                    model.value.confirmPassword = '';
                    emits('update:close', false);
                }
            });
        }
    });
};
</script>

<style scoped></style>
